import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            分类浏览
          </h2>
          <p className="text-foreground-500 text-sm max-w-md mx-auto">
            按你喜欢的类型找到专属漫画，总有一部是你想要的
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {comicCategories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group p-4 md:p-5 rounded-xl bg-background-50 border border-secondary-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${category.icon} text-xl`}></i>
              </div>
              <h3 className="text-foreground-900 font-bold text-sm mb-1 whitespace-nowrap">{category.name}</h3>
              <p className="text-foreground-400 text-xs leading-relaxed line-clamp-2 mb-2">{category.description}</p>
              <span className="text-primary-500 text-xs font-medium">{category.count} 部作品</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}